/**
 * abilityVfxZed — Zed Q/W/E/R silhouettes (SPY-610).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildRazorShuriken(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  const dark = mat(THREE, spec.color || 0x1e293b);
  const edge = mat(THREE, 0x94a3b8, 0.85);
  const star = new THREE.Mesh(new THREE.ConeGeometry(0.16 * s, 0.4 * s, 4).rotateX(Math.PI / 2), dark);
  star.position.y = 0.4 * s;
  group.add(star);
  const blade = new THREE.Mesh(new THREE.BoxGeometry(0.35 * s, 0.04 * s, 0.12 * s), edge);
  blade.position.y = 0.45 * s;
  group.add(blade);
  group.userData = { shape: 'razor_shuriken' };
  return group;
}

export function buildLivingShadow(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.2);
  const shadow = mat(THREE, spec.color || 0x334155, 0.75);
  const wisp = mat(THREE, 0x64748b, 0.6);
  const body = new THREE.Mesh(new THREE.CylinderGeometry(0.2 * s, 0.28 * s, 1.4 * s, 8), shadow);
  body.position.y = 0.7 * s;
  group.add(body);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.55 * s, 16).rotateX(-Math.PI / 2),
    wisp
  );
  ring.position.y = 0.05;
  group.add(ring);
  group.userData = { shape: 'living_shadow' };
  return group;
}

export function buildShadowSlash(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.3);
  const slash = mat(THREE, spec.color || 0x475569, 0.88);
  const arc = new THREE.Mesh(new THREE.TorusGeometry(0.45 * s, 0.06 * s, 8, 16, Math.PI), slash);
  arc.rotation.x = Math.PI / 2;
  arc.position.y = 0.5 * s;
  group.add(arc);
  group.userData = { shape: 'shadow_slash' };
  return group;
}

export function buildDeathMark(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.75 * (spec.scale || 1.4);
  const mark = mat(THREE, spec.color || 0xdc2626);
  const sigil = new THREE.Mesh(new THREE.RingGeometry(0.25 * s, 0.5 * s, 6), mark);
  sigil.rotation.x = -Math.PI / 2;
  sigil.position.y = 0.1;
  group.add(sigil);
  const spike = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.35 * s, 4), mark);
  spike.position.y = 0.55 * s;
  group.add(spike);
  group.userData = { shape: 'death_mark' };
  return group;
}
